module.exports = __webpack_public_path__ + "img/ep-J-dosis.659debe9.jpg";